'use client';

import { FC, PropsWithChildren } from 'react';
import { Portal, Drawer } from 'components/pcc-components';
import { ROOT_PORTALS } from 'constants/targets';
import { useNavigationDrawers } from '../../navigation-drawers-context';

export const AccountDrawerWrapper: FC<PropsWithChildren> = ({ children }) => {
  const { accountDrawer } = useNavigationDrawers();
  return (
    <Portal id={ROOT_PORTALS}>
      <Drawer {...accountDrawer?.drawerProps}>{children}</Drawer>
    </Portal>
  );
};
